<template>
	<div class="centerx" style="min-width: 800px;">
		<vs-popup title="Ajouter une commande" :active.sync="isPopupActive" @close-popup="closePopup()" >
			<h3>Contrat N° {{this.$props.contract.contract_id}} {{this.$props.contract.society_name}} </h3>
		<Order :apiUrl="this.$props.apiUrl" :contract="this.$props.contract" :router="this.$props.router" :show="isPopupActive" @close-popup="closePopup()" isFromPopup= true  />
		</vs-popup>
	</div>
</template>

<script>

import Order from "../forms/order/Order.vue";
import "flatpickr/dist/flatpickr.css";
import "flatpickr/dist/plugins/monthSelect/style.css";


export default {
	name: "NewCommandePopup",
	props: {
		contract: Object,
		popupActive: Boolean,
		apiUrl: String,
		router: Object
	},
	components: {
		Order,
	},
	methods: {
		closePopup(){
			//console.log("close pop up ");
			this.isPopupActive = false;
		},
	},
	data() {
		return {
			isPopupActive: this.$props.popupActive
		};
	}

};
</script>

<style>
#product_options>.input-select-con{
	width: 100%;
}

.nowrap {
  display: flex;
  align-items: baseline;
}

.role_selector_container {
  justify-content: space-between;
  width: 40%;
}

.role_container {
  justify-content: center;
}

.space_div {
  margin: 5px;
}

</style>
